// Language identity comes from the shared registry; the 18-name
// LANGUAGE_NAME_TO_CODE copy that used to live here has been removed.
// SOURCES_LABEL_BY_LANG below is genuinely different data — translated UI
// strings, not language identity — so it stays.
import { toIso2 } from '../../utils/languages';

// "Sources" translated for every language we offer.  Falls back to English
// when the language is unknown.
const SOURCES_LABEL_BY_LANG = {
    en: 'Sources',
    es: 'Fuentes',
    zh: '来源',
    hi: 'स्रोत',
    fr: 'Sources',
    de: 'Quellen',
    ar: 'المصادر',
    pt: 'Fontes',
    it: 'Fonti',
    ru: 'Источники',
    he: 'מקורות',
    uk: 'Джерела',
    fa: 'منابع',
    tr: 'Kaynaklar',
    el: 'Πηγές',
    no: 'Kilder',
    cs: 'Zdroje',
    nl: 'Bronnen',
};

const RTL_CODES = new Set(['he', 'ar', 'fa']);
const RTL_NAMES = new Set(['hebrew', 'arabic', 'persian', 'farsi']);

export function isRtlLanguageName(language) {
    if (!language) return false;
    const s = String(language).trim().toLowerCase();
    return RTL_CODES.has(s) || RTL_NAMES.has(s);
}

function codeFromLanguage(language) {
    // Accepts a name or any spelling of a code; SOURCES_LABEL_BY_LANG is keyed
    // by ISO 639-1, so resolve to that.
    return toIso2(language) || 'en';
}

// Returns the "Sources" label for a given language (name or code).
export function getSourcesLabel(language) {
    const code = codeFromLanguage(language);
    return SOURCES_LABEL_BY_LANG[code] || SOURCES_LABEL_BY_LANG.en;
}

// All possible source-label prefixes, used by the Copy button to strip
// the trailing "Sources:" footer no matter which language the brief is in.
export const ALL_SOURCE_LABELS = Object.values(SOURCES_LABEL_BY_LANG);
